import styled from 'styled-components'
import { motion } from 'framer-motion'

export const Content = styled(motion.div)`

`

export const Title = styled(motion.h3)`
    margin: 0 0 1rem 0;
`

export const ButtonContainer = styled(motion.div)`
    display: flex;
    align-items: flex-start;
`
    
export const ImgContainer = styled(motion.button)`
    display: inline-block;
    margin-right: 1rem;
    background-color: transparent;
`

export const Img = styled.img`
    width: 100%;
    height: 100%;
    pointer-events: none;
`
